// extracted by mini-css-extract-plugin
export var navigationMenuItem = "NavigationMenuItem-module--navigationMenuItem--2RqtN";
export var activeLink = "NavigationMenuItem-module--activeLink--2nbB-";